import React, { useEffect } from 'react';
import { useMsal } from '@azure/msal-react';

const LoginButton: React.FC = () => {
  const { instance } = useMsal();

  const handleLogin = () => {
    instance.loginRedirect().catch((error: any) => {
      console.error("Error during login redirect:", error);
    });
  };

  useEffect(() => {
    instance.handleRedirectPromise().then((response: any) => {
      if (response && response.account) {
        instance.setActiveAccount(response.account);
        console.log("Login successful. Active account:", response.account);
      } else {
        const activeAccount = instance.getActiveAccount();
        if (activeAccount) {
          console.log("Active account already set:", activeAccount);
        } else {
          console.warn("No active account found after login.");
        }
      }
    }).catch((error: any) => {
      console.error("Error handling redirect response:", error);
    });
  }, [instance]);

  return <button onClick={handleLogin}>Login</button>;
};

export default LoginButton;
